import React from 'react';
import { withRouter } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';

//COMPONENTS
import {Row, Column, IBox, Title, Content, Return, Button,Icon} from '../inspinia'
import Pagination from 'react-js-pagination';

class ListaDetalheValidar extends React.PureComponent
{
    constructor(props)
    {
        super(props);     
        
        this.state ={
           
            idListaErro: props.match.params.id,
            listasValidada:
                {
                  dataFim: '',
                  dataInicio: '',
                  emailUsuario: '',
                  finalizada: '',
                  id: '',
                  linhasValidadas: [
                    {
                      conteudo: '',
                      erro: '',
                      linha: ''
                    }
                  ],
                  nomeArquivo: '',
                  status: ''
                },
            loading: false, 
            optionsGet : { method: 'GET' , headers: { 'Content-Type': 'application/json' } },
        }
        this.handleImportarNovaLista = this.handleImportarNovaLista.bind(this);
    }
    
    componentDidMount()
    {
        this.loadListaErros();
    }

    loadListaErros()
    {
        let self = this;
        let id = this.state.idListaErro;

        const url = `${ c.API_BASE_URL }/list-validate/show/${id}`;
        const options = self.state.optionsGet;
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        { 
            self.setState({...self.state, loading : false , listasValidada: response});
        });
    }

    handleImportarNovaLista(){
        let id = this.state.idListaErro;
        
        this.props.history.push(c.CAMPAIGN_ROUTE + "/lista/upload/validar/"+ id);
    }

    render()
    {
        return (            
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-4">
                    <Column>                   
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Erros</h3>
                            </Title>
                            <Content>
                                {/* MENU DE OPÇÕES */}
                                <Row className="m-0 mb-3">
                                    <Column size="12" className="p-0 mx-auto container">

                                        <Button onClick={this.handleImportarNovaLista}><Icon name="fa-plus"/>Enviar Lista Novamente</Button> 

                                    </Column>
                                    
                                </Row>

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">
                                        
                                        <Table data={this.state.listasValidada.linhasValidadas} history={this} recarregar={true}/>                                        
                                    
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>                        
                    </Column>
                </Row>

                {/* FOOTER */}
                <Row className="mb-5">
                    <Column className="container">
                        <Row>
                            <Column size="4" className="text-left">
                    
                                    <Return to={c.CAMPAIGN_ROUTE+"/lista/validar"} width="130px" />

                            </Column>
                        </Row>                     
                    </Column>
                </Row>
                
            </div>
        );
    }
}

class Table extends React.Component
{
    constructor(props) {
        super(props);

        this.state = {
            page: 0,
            list:
            {
                currentPage: 0, pageCount: 0, pageSize: 0, rowCount: 0, results: undefined
            },
            recarregar: this.props.recarregar,
        }

        this.handlePageChange = this.handlePageChange.bind(this);
        this.loadListErrors = this.loadListErrors.bind(this);
    }

    componentDidUpdate() {
        if ((this.props.data !== undefined && this.props.data[0].linha !== '')
            && this.state.recarregar) {
            this.state.recarregar = false;
            this.loadListErrors(this.state.page);
        }
    }

    handlePageChange(pageNumber) {
        this.state.page = pageNumber;
        this.loadListErrors(pageNumber);
    }

    loadListErrors(pageNumber) {
        let erros = this.props.data;

        let page = pageNumber === undefined || pageNumber === 0 ? 0 : pageNumber - 1;
        let limit = 10;
        let slice1 = page * limit;
        let slice2 = limit * (page + 1);

        this.setState({
            ...this.state,
            list: {
                ...this.state.list,
                results: erros.slice(slice1, slice2),
                pageSize: limit,
                rowCount: erros.length,
                currentPage: this.state.page
            }
        });
    }

    render()
    {    
        const data = this.state.list.results; 
        let html = "";

        if (data === undefined)
        {
            html = (<tr><td colSpan="7" scope="row">Carregando...</td></tr>);
        }
        else if (data.length === 0)
        {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.length   > 0)
        {
            html = data.map((row, index) =>
                <tr key={index} id={row.linha}>
                    <td>{row.linha}</td>
                    <td>{row.conteudo}</td>
                    <td>{row.erro}</td>              
                </tr>                  
            );
        }

        return (
            <div>
                <table className="footable table table-striped toggle-arrow-tiny text-body">
                    <thead>
                        <tr style={{backgroundColor: "#dbf1e9"}}>       
                            <th>Linha</th>
                            <th>Conteudo</th>
                            <th>Erro</th>
                        </tr>
                    </thead>

                    <tbody>{html}</tbody>
                </table>

                {/* FOOTER */}
                <Row className="mb-5">
                    <Column className="container">
                        <Row>
                            <Column size="12" className="text-center">
                                <div className="d-flex justify-content-center">

                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={c.DEFAULT_PAGE_RANGE}
                                        activePage={this.state.page}
                                        itemsCountPerPage={this.state.list.pageSize}
                                        totalItemsCount={this.state.list.rowCount}
                                        onChange={this.handlePageChange}
                                    />

                                </div>
                            </Column>
                        </Row>
                    </Column>
                </Row>
            </div>
        )
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListaDetalheValidar));
